import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {UtilsService} from "../../shared/utils.service";
import {ApiRequestService} from "../../shared/api-request.service";
import {UserPublicProfileComponent} from "../../shared/user-public-profile/user-public-profile.component";
import {VendorModel} from "../../models/vendor.model";
import { AppService } from '../../app.service';

@Component({
  selector: 'app-vendors-view',
  templateUrl: './vendors-view.component.html',
  styleUrls: ['./vendors-view.component.scss']
})
export class VendorsViewComponent implements OnInit {
  vendor: VendorModel = new VendorModel();

  constructor(
    @Inject(MAT_DIALOG_DATA) private id: number,
    public utils: UtilsService,
    public app: AppService,
    private api: ApiRequestService
  ) {}

  ngOnInit() {
    const vendor_id = this.id;
    if (vendor_id) {
      this.getVendor(vendor_id);
    }
  }

  /**
   * Retrieves the Vendor with the specified ID.
   *
   * @param {number} id - The unique identifier of the vendor to retrieve.
   * @return {void}
   */
  private getVendor(id: number): void {
    this.api
      .makeRequest('get', `v2/vendors/${id}`)
      .then((response) => {
        this.vendor = response.data;
      })
      .catch((errorResponse) => {
        this.utils.handleAPIErrors(errorResponse);
      });
  }

  /**
   * Open the User's public profile dialog.
   *
   * @param hash
   * @return {void}
   */
  onUserPublicView(hash: string): void {
    this.utils.showComponentDialog(
      UserPublicProfileComponent,
      hash,
      { width: '90%' },
      () => {
        // Refresh the list regardless of how the dialog is closed.
      }
    );
  }
}
